import { IHeaderViewModelTranslations } from 'Types/Litium';

interface IHamburgerButton {
    isActive: boolean;
    onClickHandler: () => void;
    translations: IHeaderViewModelTranslations;
}

const HamburgerButton = ({
    isActive = false,
    onClickHandler,
    translations,
}: IHamburgerButton) => (
    <button
        className="block lg:hidden"
        onClick={onClickHandler}
        type="button"
        aria-label={isActive ? translations.close : translations.open}
        aria-expanded={isActive}
    >
        <span
            className={` tham tham-e-squeeze tham-w-6 ${
                isActive ? 'tham-active' : ''
            }`}
        >
            <span className="tham-box">
                <span className="tham-inner !h-[1px] before:!h-[1px] after:!h-[1px]" />
            </span>
        </span>
    </button>
);

export default HamburgerButton;
